export default __webpack_public_path__ + "static/media/img11.53ab89ce.png";